import { render, staticRenderFns } from "./ItemBasicLayout.vue?vue&type=template&id=3c9a39d9&scoped=true"
import script from "./ItemBasicLayout.vue?vue&type=script&lang=js"
export * from "./ItemBasicLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9a39d9",
  null
  
)

export default component.exports